module.exports = __webpack_public_path__ + "static/media/1.f303e3fa.jpg";